import { Button, Icon } from '@acpaas-ui/react-components';
import { useRef } from 'react';
import SelectField from '../../components/forms/SelectField';
import TextField from '../../components/forms/TextField';
import { TEMPLATE_CATEGORIES_OPTIONS } from '../../constants/templates.constants';
import formValidators from '../../form-validators';
import { useResourceInput } from '../../hooks/useResourceInput';
import templatesService from '../../services/api/templates.service';
import Modal from '../Modal';
import ModalTitle from '../ModalTitle';

const INPUT_NAME = 'spo-update-template-textfield';

const UpdateTemplateModal = ({ isOpen, onClose, onDelete, onUpdated, form }) => {
  const modalContentRef = useRef(null);
  const { data, load, reset, isSubmitting, submitStart, submitOk, submitError } = form;
  const resource = {
    isFetching: !isOpen,
    isSubmitting,
    getValue: (field) => data?.[field],
    setValue: (value, field, options) => {
      submitStart();
      templatesService.update(
        data?.id,
        { [field]: value },
        {
          onError: (message) => {
            submitError({ [field]: message });
            if (options.onError) {
              options.onError(message);
            }
          },
          onSuccess: () => {
            submitOk();
            options?.onSuccess && options.onSuccess();
            onUpdated();
          }
        }
      );
    },
    onCancel: reset,
    validators: {
      name: formValidators.required,
      category: formValidators.required
    }
  };

  const handleClose = () => {
    load({});
    onClose();
  };

  return (
    <Modal
      ref={modalContentRef}
      className="spo-o-update-template-modal"
      title={<ModalTitle title="Sjabloon aanpassen" />}
      isOpen={isOpen}
      onClose={handleClose}
      disableConfirm
      disableCancel
      isSubmitting={isSubmitting}
      extraFooterActions={
        <Button type="danger" outline disabled={isSubmitting} onClick={onDelete}>
          Verwijderen
        </Button>
      }
    >
      <TextField required label="Naam" name={INPUT_NAME} {...useResourceInput('name', resource)} />
      <SelectField
        id="add-template-modal-category"
        label="Categorie"
        name={'category'}
        required
        options={TEMPLATE_CATEGORIES_OPTIONS}
        parentElement={modalContentRef.current}
        className="u-margin-top"
        isSubmitting={isSubmitting}
        {...useResourceInput('category', resource)}
      />
      <div className="u-margin-top-md u-margin-bottom u-text-primary">
        <Icon name="ai-download-bottom" className="u-margin-right-xs" />
        <a href={data?.fileUrl} rel="noreferrer" target="_blank">
          {data?.fileKey}
        </a>
      </div>
    </Modal>
  );
};

export default UpdateTemplateModal;
